
const routes = [
  {
    path: '/clickFarming',
    name: 'clickFarming',
    component(resolve) {
      require.ensure(['./views/clickFarming.vue'], () => {
        resolve(require('./views/clickFarming.vue'));
      });
    },
  },
  {
    path: '/login',
    name: 'login',
    component(resolve) {
      require.ensure(['./views/login.vue'], () => {
        resolve(require('./views/login.vue'));
      });
    },
  },
  {
    path: '/actionSuccess',
    name: 'actionSuccess',
    component(resolve) {
      require.ensure(['./views/actionSuccess.vue'], () => {
        resolve(require('./views/actionSuccess.vue'));
      });
    },
  },
  {
    path: '/serviceIntro',
    name: 'serviceIntro',
    component(resolve) {
      require.ensure(['./views/serviceIntro.vue'], () => {
        resolve(require('./views/serviceIntro.vue'));
      });
    },
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component(resolve) {
      require.ensure(['./views/privacyPolicy.vue'], () => {
        resolve(require('./views/privacyPolicy.vue'));
      });
    },
  },
  {
    path: '/jlwServiceIntro',
    name: 'jlwServiceIntro',
    component(resolve) {
      require.ensure(['./views/jlwServiceIntro.vue'], () => {
        resolve(require('./views/jlwServiceIntro.vue'));
      });
    },
  },
  {
    path: '/jlwPrivacyPolicy',
    name: 'jlwPrivacyPolicy',
    component(resolve) {
      require.ensure(['./views/jlwPrivacyPolicy.vue'], () => {
        resolve(require('./views/jlwPrivacyPolicy.vue'));
      });
    },
  },
  {
    path: '*',
    component(resolve) {
      require.ensure(['./views/blank.vue'], () => {
        resolve(require('./views/blank.vue'));
      });
    },
  }
];


export default routes;



// WEBPACK FOOTER //
// ./src/routers.js